export function HorizontalSeparator() {
  return <div className="h-[1px] bg-neutral-4" />;
}
